export interface MenuLinkMetadata {
  target?: string | null;
  title?: string | null;
  rel?: string | null;
  [key: string]: unknown;
}

export interface MenuItem {
  id?: string | number;
  label?: string | null;
  text?: string | null;
  title?: string | null;
  href?: string | null;
  link?: string | null;
  route?: string | null; // Backend'den gelen route alanı (UrlPatternService ile oluşturulmuş)
  type?: string | null;
  image?: string | null;
  svg?: string | null;
  target?: string | null;
  children?: MenuItem[];
  subItems?: MenuItem[];
  items?: MenuItem[];
  metadata?: MenuLinkMetadata;
  [key: string]: unknown;
}

export interface MenuData {
  items?: MenuItem[];
  [key: string]: unknown;
}

export interface LanguageAttribute {
  code: string;
  name?: string | null;
  [key: string]: unknown;
}

export interface MenuAttributes {
  title?: string | null;
  slug?: string | null;
  position?: string | null;
  is_active?: boolean;
  language?: LanguageAttribute | null;
  data?: MenuData | MenuItem[] | null;
  [key: string]: unknown;
}

export interface MenuEntity {
  id: number;
  attributes: MenuAttributes;
}

export interface LaravelResponse<T> {
  data: T;
  meta?: Record<string, unknown>;
}

export type MenuResponse = LaravelResponse<MenuEntity | MenuEntity[]>;

export interface ContactInfoAttributes {
  company_name?: string | null;
  phone?: string | null;
  whatsapp?: string | null;
  email?: string | null;
  address?: string | null;
  lat?: string | null;
  lng?: string | null;
  working_hours?: string | null;
  language?: {
    code?: string | null;
    name?: string | null;
  };
}

export interface ContactInfoEntity {
  id: number;
  attributes: ContactInfoAttributes;
}

export interface SocialMediaAttributes {
  title?: string | null;
  href?: string | null;
  icon?: string | null; // Icon adı (facebook, twitter, etc.) veya null
  svg?: string | null; // SVG kodu
  language?: {
    code?: string | null;
    name?: string | null;
  };
}

export interface SocialMediaEntity {
  id: number;
  attributes: SocialMediaAttributes;
}

export interface HeaderPayload {
  /** Mevcut site ID (form detay vb. API isteklerinde kullanılır) */
  site_id?: number;
  languages?: {
    data: unknown[];
    default_code?: string;
    [key: string]: unknown;
  };
  menus?: Record<string, MenuEntity | undefined>;
  social_medias?: {
    data: SocialMediaEntity[];
    [key: string]: unknown;
  };
  contact_info?: ContactInfoEntity | null;
  general_settings?: Record<string, unknown>;
  seo_settings?: Record<string, unknown>;
  meta?: Record<string, unknown>;
  [key: string]: unknown;
}

export type HeaderPayloadResponse = LaravelResponse<HeaderPayload>;

export const isMenuEntityArray = (
  data: MenuEntity | MenuEntity[] | undefined
): data is MenuEntity[] => Array.isArray(data);

export const ensureMenuEntity = (
  data: MenuEntity | MenuEntity[] | undefined
): MenuEntity | undefined => {
  if (!data) {
    return undefined;
  }

  return isMenuEntityArray(data) ? data[0] : data;
};

export const extractMenuItems = (
  source?: MenuData | MenuItem[] | null
): MenuItem[] => {
  if (!source) {
    return [];
  }

  if (Array.isArray(source)) {
    return source;
  }

  if (Array.isArray(source.items)) {
    return source.items;
  }

  return [];
};

